module.exports = __webpack_public_path__ + "static/media/image2.8fc10236.png";